/**
 * Centralized membership feature access helpers for Vitality FE.
 * Keys match the portal menu catalogue from the backend.
 */

export const MEMBERSHIP_FEATURE_KEYS = Object.freeze({
  ORDER_LABS: "order_labs",
  BOOK_CONSULT: "book_consult",
  LAST_SESSION: "last_session",
  COURSES: "courses",
  MEMBERSHIPS: "memberships",
  SHOP: "shop",
  COMMUNITY: "community",
  EVENTS: "events",
  SEARCH: "search",
});

/**
 * @param {object|null|undefined} user - Redux user object
 * @param {string} featureKey
 * @returns {boolean}
 */
export function hasFeature(user, featureKey) {
  const key = String(featureKey || "").trim();
  if (!key) return false;
  const features = Array.isArray(user?.membershipFeatures)
    ? user.membershipFeatures
    : [];
  return features.includes(key);
}

/**
 * Members must have the entitlement. Non-members keep join-funnel visibility
 * for features that previously prompted Subscribe / Members Only.
 */
export function canShowMemberFeature(user, featureKey, { isMember } = {}) {
  const member =
    typeof isMember === "boolean"
      ? isMember
      : Array.isArray(user?.membershipFeatures); // caller should pass isMember
  if (!member) return true;
  return hasFeature(user, featureKey);
}
